import { useRef, type FormEvent, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useFokusfalle } from "./useFokusfalle.ts";

export interface FxDialogProps {
  titelId: string;
  titel: string;
  untertitel?: ReactNode;
  /** Waehrend des Speicherns bleibt der Dialog offen (Escape und Klick daneben sind wirkungslos). */
  beschaeftigt: boolean;
  /** Breiter Rahmen fuer Dialoge mit Tabellen-/Feldgruppen (Detail-Panel). */
  breit?: boolean;
  onSchliessen: () => void;
  onAbsenden: (ereignis: FormEvent<HTMLFormElement>) => void;
  fuss: ReactNode;
  children: ReactNode;
}

/** Modaler Rahmen der Zahlungsseiten-Dialoge: gleiche Bauart wie `SicherungAnlegenDialog` (Overlay, Fokusfalle, Escape). */
export function FxDialog({ titelId, titel, untertitel, beschaeftigt, breit = false, onSchliessen, onAbsenden, fuss, children }: FxDialogProps) {
  const dialogRef = useRef<HTMLElement>(null);
  const beschaeftigtRef = useRef(beschaeftigt);
  beschaeftigtRef.current = beschaeftigt;

  useFokusfalle({ dialogRef, beschaeftigtRef: beschaeftigtRef, onSchliessen });

  return createPortal(
    <div className="board-editor-overlay open" role="presentation" onClick={(ereignis) => {
      if (!beschaeftigtRef.current && ereignis.target === ereignis.currentTarget) onSchliessen();
    }}>
      <section ref={dialogRef} className={`board-editor-dialog fx-sicherung-anlegen-dialog fx-dialog${breit ? " fx-dialog-breit" : ""}`} role="dialog" aria-modal="true" aria-labelledby={titelId} tabIndex={-1}>
        <form className="password-form" onSubmit={onAbsenden}>
          <div className="board-editor-head"><div className="board-editor-head-copy"><h2 id={titelId}>{titel}</h2>{untertitel ? <p>{untertitel}</p> : null}</div></div>
          <div className="board-editor-body fx-sicherung-anlegen-fields">{children}</div>
          <div className="board-editor-foot">{fuss}</div>
        </form>
      </section>
    </div>,
    document.body,
  );
}
